import React from 'react';
import { useDepartments, useOffices, useShips } from '../../services/Firestore/Resources';
import AuthContext from '../../services/AuthContext/AuthContext';
import MyAccount from '../../views/MyAccount/MyAccount';

const MyAccountPage = () => {
  const [departments, departmentsLoading] = useDepartments();
  const [ships, shipsLoading] = useShips();
  const [offices, officesLoading] = useOffices();

  if (departmentsLoading || shipsLoading || officesLoading) {
    return <div>Loading...</div>;
  }
  return (
    <AuthContext.Consumer>
      {(currentUser) =>
        currentUser && <MyAccount {...{ currentUser, departments, ships, offices }} />
      }
    </AuthContext.Consumer>
  );
};

export default MyAccountPage;
